/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

export default function IndividualDiscountTooltip({prod,hover,i}) {
    const [searchParam, setSearchParam] = useSearchParams()
    const id = searchParam.get('code')
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01]
            }} id="tooltip-discountPercentage" role="tooltip" className={`inline-block absolute ${hover?'visible':'invisible'} z-10 sm:pl-5 sm:pr-4 px-2 pb-2 sm:pt-4 pt-2.5 bg-white rounded-lg shadow-s2 w-[210px]`}>
            <p className="text-xs6 font-semibold text-[#090406]">Offer Applied</p>
            <p className="text-xs13 font-semibold text-[#555259] pt-[3px]">{id} |{`Criteria ${Number(i)+1}`}</p>
            <div className="flex items-center justify-between pt-2.5">
                <p className="text-sm font-normal text-[#555259]">Trade Discount</p>
                <p className="text-lg font-semibold text-[#555259]">{prod.discount_parameter==='0'?Number(prod?.trade_discount).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                }):`${prod?.TRADE_DISCOUNT}%`}</p>
            </div>
            <div className="flex items-center justify-between pt-1">
                <p className="text-sm font-normal text-[#555259]">Additional Discount </p>
                <p className="text-lg font-semibold text-[#555259]">{prod.discount_parameter==='0'?Number(prod?.ADDITIONAL_DISCOUNT).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                }):`${prod?.ADDITIONAL_DISCOUNT}%`}</p>
            </div>
            <div className="tooltip-arrow" data-popper-arrow></div>
        </motion.div>
    )
}
